import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import { clearCookie, getCookie } from "../../utilities/cookies";
import { normalizeRedirectUrl } from "../../utilities/authRedirect";
import { clearIdentityTransaction } from "../../gateway/identityTransaction";

const DEFAULT_LOGOUT_DESTINATION = "https://clikkle.com/";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    const redirectValue = new URLSearchParams(window.location.search).get("redirectto");
    const destination = normalizeRedirectUrl(redirectValue) || DEFAULT_LOGOUT_DESTINATION;
    const session = getCookie("user");

    const finish = () => {
      clearCookie("user");
      clearIdentityTransaction();
      if (!active) return;
      if (destination) window.location.replace(destination);
      else navigate("/login", { replace: true });
    };

    const logout = async () => {
      if (!session?.success || !session?.user?._id || !session?.sessionToken) {
        finish();
        return;
      }

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 5000);
      try {
        const formData = new FormData();
        formData.append("sessionToken", session.sessionToken);
        formData.append("userId", session.user._id);
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/auth/logout`, {
          method: "POST",
          body: formData,
          signal: controller.signal,
        });
      } catch (error) {
        console.warn("Accounts server logout could not be confirmed; local session was still cleared.", error);
      } finally {
        window.clearTimeout(timeout);
        finish();
      }
    };

    logout();
    return () => { active = false; };
  }, [navigate]);

  return <Loading message="Please wait while we sign you out…" />;
}
